import CustomCard from "components/Atoms/CustomCard"
import CustomButton from "components/Atoms/CustomButton"
import StyledLink from "components/Atoms/StyledLink"
import Toggle from "components/Atoms/Toggle"
import Error from "components/Common/Error"
import ReactTableHeader from "components/Common/ReactTableHeader"
import TablePagination from "components/Molecules/TablePagination"
import SerialColumn from "components/Organisms/table/SerialColumn"
import CustomReactTable from "components/Templates/CustomReactTable"
import ROUTES from "constants/routes.constants"
import { useDcDocksQuery, useDockAddUpdateMutation } from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import DockFilter from "pages/registration/dock/DockFilter"
import React, { useEffect } from "react"
import { useLocation, useNavigate } from "react-router"
import { useSearchParams } from "react-router-dom"
import { useFilter } from "store/search-filter/search-filter.reducer"
import AppToaster from "utils/AppToaster"
const PAGE_SIZE = 12
const Docks = () => {
  const [filter] = useFilter("docks")

  const navigate = useNavigate()
  const [{ search, page }, setFilter] = useSearchFilter()
  const [params, setParams] = useSearchParams()
  const updated = params.get("update")
  const { loading, error, data, refetch } = useDcDocksQuery({
    variables: {
      filter: {
        distributionCentreId: filter?.distributionCentre?.id,
        depotId: filter?.depot?.id,
      },
      query: search,
      first: PAGE_SIZE,
      skip: PAGE_SIZE * page,
    },
  })

  useEffect(() => {
    if (updated) {
      refetch()
      params.delete("update")
      setParams(params)
    }
  }, [updated])
  const COLUMNS = [
    SerialColumn,
    {
      width: 100,
      accessor: "archive",
      Header: "Status",
      Cell({ original }) {
        const archived = original?.archive
        const [toggle] = useDockAddUpdateMutation({
          onCompleted({ addUpdateDock: { dock } }) {
            AppToaster.show({
              intent: "success",
              message: `Dock ${dock.name} is now ${
                dock.archive ? "archived" : "active"
              }`,
            })
          },
        })
        if (original?.id?.startsWith("vt")) return <></>
        return (
          <Toggle
            intent="success"
            checked={!archived}
            onChange={() => {
              toggle({
                variables: {
                  archive: !archived,
                  distributionCentreId: original?.distributionCentre?.id,
                  id: original?.id,
                },
              })
            }}
            innerLabel={archived ? "Archived" : "Active"}
          />
        )
      },
    },
    {
      Header: "Dock Name",
      accessor: "name",
      className: "text-left px-3",
      Cell({ value, original }) {
        return (
          <StyledLink
            to={{
              pathname: ROUTES.dockDetail(original?.id),
            }}
          >
            {value}
          </StyledLink>
        )
      },
    },
    {
      Header: "Abbreviation",
      accessor: "codename",
      className: "text-left px-3",
      Cell({ value }) {
        return <>{value}</>
      },
    },
    {
      Header: "Distribution Center",
      accessor: "distributionCentre",
      className: "text-left px-3",
      width: 250,
      Cell({ value }) {
        const { search } = useLocation()
        if (!value?.id) return "--"
        return (
          <StyledLink
            to={{
              pathname: ROUTES.dcDetail(value?.id),
              search,
            }}
          >
            {value?.name}
          </StyledLink>
        )
      },
    },
    {
      Header: "Depot",
      accessor: "depot",
      className: "text-left px-3",
      Cell({ value }) {
        return <>{value?.name}</>
      },
    },
  ]

  if (error) return <Error message={error?.message} />

  return (
    <CustomCard className="w-full p-0" style={{ borderRadius: 7 }}>
      <ReactTableHeader
        title="Dock"
        icon="truck"
        value={search}
        filter={<DockFilter />}
        onQueryChange={search => {
          setFilter(prev => ({
            ...prev,
            search,
            page: 0,
          }))
        }}
      >
        <TablePagination
          className="mr-6"
          page={page}
          onPageChange={v =>
            setFilter(prev => ({
              ...prev,
              page: v,
            }))
          }
        />
        <CustomButton
          text="Dock"
          icon="plus"
          dark={true}
          onClick={() => navigate(ROUTES.dockDetail("new"))}
        />
      </ReactTableHeader>
      <CustomReactTable
        loading={loading}
        data={data?.allDocks || []}
        columns={COLUMNS}
        pageSize={PAGE_SIZE}
      />
    </CustomCard>
  )
}

export default Docks
